import { motion } from "framer-motion";

function Contact() {
  return (
    <motion.div 
      id="contact" 
      style={{width: '100%', position: 'relative'}}
      initial={{ opacity: 0, y: 75 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8 }}
    >
      <div className="contact-hub-section">
        {/* Full Screen Map Background */}
        <div className="map-background">
          <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d822.4880101731117!2d106.74868336528954!3d-6.584058420104786!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69c546f7ad7955%3A0x6fbd9c68c3c75af7!2sTEAM%20GEO%20SOLUTION!5e0!3m2!1sen!2sid!4v1767760960474!5m2!1sen!2sid" 
            className="map-iframe" 
            allowFullScreen="" 
            loading="lazy" 
            referrerPolicy="no-referrer-when-downgrade"
            title="Office Location"
          ></iframe>
        </div>

        {/* Floating Glass Card */}
        <div className="glass-card">
          <h2>Global Headquarters</h2>
          <p className="address-text">
            Perumahan Casa Samala Laladon, Blok G-5, Ciherang, Dramaga, Bogor Regency, West Java, 16680, Indonesia
          </p>

          <div className="hub-divider"></div>

          {/* APAC Support */}
          <div className="contact-group">
            <h4><span></span>Head Operation & Remote Office (APAC)</h4>
            <div className="contact-details">
              <p><strong>T.</strong> +62 812 6000 766</p>
              <p><strong>E.</strong> ocean@solusion7.com</p>
            </div>
          </div>

          {/* EMEA Support */}
          <div className="contact-group">
            <h4><span></span>Technical Support and Development (EMEA Region)</h4>
            <div className="contact-details">
              <p><strong>E.</strong> EMEA@solusion7.com</p>
            </div>
          </div>

        </div>
      </div>
    </motion.div>
  );
}
export default Contact;
